<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><span class="bold">REBEL KING</span></h1>
<p class="subtitle"><span class="bold">The Making of a Monarch</span></p>
<p class="author"><a id="page_iii"></a>Tom Bower</p>
<div class="img_containert">
<img alt="image" src="images/logo.jpg"/>
</div>
<a id="page_iv"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?3cc57652